/**
 * 参考资料
 */

import React, { useMemo, useState, useCallback, useEffect } from "react";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { getSimpleTextRemark } from "@/components/chat/utils/commonMessageModal";

// const mockData = [
//   "【1】[隐藏个人信息.docx](https://jzb-pre.jdcloud.com/joyspace/file/GN2qKY66C4xMUUHDlDGD)",
//   "【2】[【027期】如何在京办建立单位共享知识库？.docx](https://jzb-pre.jdcloud.com/joyspace/file/hjN7rJr85povnXnrRzCk)",
//   "【3】[【052期】巧用个人账号消息框.docx](https://jzb-pre.jdcloud.com/joyspace/file/F28zPDX274uhogdjDpeC)"
// ];

function ReferenceHeader(props: any) {
  const { refs = [] } = props;
  console.log("header--refs", refs);
  const [showDetail, setShowDetail] = useState<boolean>(false);

  if (!refs?.length) return null;
  return (
    <div className={`${styles["reference-detail-wrap"]} ${showDetail ? styles["showMore"] : ""}`}>
      <div className={styles["header-wrap"]} onClick={() => setShowDetail(!showDetail)}>
        <IconFont className={styles["icon"]} type="iconpc_ic_chenggong_doc" />
        <span className={styles["text"]}>{`已搜索到${refs?.length}篇文献`}</span>
        <IconFont
          className={styles["arrow"]}
          height={7}
          width={12}
          type={showDetail ? "iconicon_up" : "iconicon_down"}
        />
      </div>
      <div className={styles["detail-wrap"]}>
        {refs?.length > 0 ? (
          <div className={styles["card-wrap"]}>
            <div className={styles["list-wrap"]}>
              {refs?.map((p: any, idx: number) => {
                return typeof p === "string" ? (
                  <div
                    key={idx}
                    dangerouslySetInnerHTML={{
                      __html: getSimpleTextRemark(p).trim()
                    }}
                  />
                ) : (
                  <div>{`【${idx + 1}】${p.source}`}</div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ReferenceHeader;
